<ac-form *ngIf="dialogConfig.ready"
         [formSchema]="additionalSettings.isLogin ? {} : commercialInfoSchema"
         [formModel]="commercialInfo"
         [auxiliaryModel]="additionalSettings"
         formModelName="commercialInfo"
         [formSettings]="formSettings"
         [requiredsAuxiliaryForm]="['additionalSettings.approval']">

    <div id="commercial-info-content">
        <ng-container *ngIf="!additionalSettings.isLogin">
            <ac-input-container formFieldName="commercialInfo.channelPONumber" label="Channel PO Number">
                <ac-textfield [(acModel)]="commercialInfo.channelPONumber"
                              textFieldId="commercial-info-channel-po-number">
                </ac-textfield>
            </ac-input-container>

            <ac-input-container formFieldName="commercialInfo.terms" label="Terms">
                <ac-single-select [items]="groupsActions.termsList"
                                  [acModel]="commercialInfo.terms"
                                  (acModelChange)="commercialInfo.terms = $event"
                                  bindLabel="text"
                                  bindValue="value">
                </ac-single-select>
            </ac-input-container>

            <div class="payment-terms-label">Payment Terms</div>
            <ac-radio-buttons-group [(acModel)]="commercialInfo.paymentTerms" label="Payment Terms"
                                    [items]="groupsActions.paymentTerms.options"
                                    radioButtonId="radio-button-commercial-info-payment-terms">
            </ac-radio-buttons-group>

            <ac-input-container formFieldName="commercialInfo.deploymentType" label="Deployment Type">
                <ac-single-select [items]="groupsActions.deploymentTypeList"
                                  [acModel]="commercialInfo.deploymentType"
                                  (acModelChange)="commercialInfo.deploymentType = $event"
                                  bindLabel="text"
                                  bindValue="value">
                </ac-single-select>
            </ac-input-container>

            <ac-input-container *ngIf="commercialInfo.deploymentType === 'POC'"
                                class="commercialInfo-poc-expiry-date"
                                label="POC Expiry Date"
                                formFieldName="additionalSettings.pocExpiryDate">
                <ac-date-picker [hourOnly]="true"
                                [minDate]="minPocExpiryDate"
                                [date]="additionalSettings.pocExpiryDate"
                                (dateChange)="onPocExpiryDateChange($event)"
                ></ac-date-picker>
            </ac-input-container>

            <ac-input-container formFieldName="commercialInfo.dpaNumber" label="DPA Number">
                <ac-textfield [(acModel)]="commercialInfo.dpaNumber"
                              textFieldId="commercial-info-dpa-number">
                </ac-textfield>
            </ac-input-container>
        </ng-container>

        <div class="terms-and-condition-label">Terms & Conditions</div>
        <file-selection (fileIdChanged)="additionalSettings.commitmentFileId = $event"
                        (fileWasUploaded)="additionalSettings.fileWasUploaded = $event"
                        filePropertyName="commitmentFileId"
                        fileType="COMMITMENT_TYPE"
                        [ngDisabled]="true"
                        [showFileSelection]="false"
                        [showImage]="false"
                        [showText]="true"
                        [fileTypes]="['txt', 'md']"
                        [fileObject]="additionalSettings"
                        [tenantId]="additionalSettings?.tenantId">
        </file-selection>


        <ac-checkbox labelText="Click to approve"
                     [(acModel)]="additionalSettings.approval"
                     (acModelChange)="approvalChanged()"
                     checkboxId="tenant-is-commitment-enabled">
        </ac-checkbox>
    </div>

</ac-form>
